import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageDetector from 'i18next-browser-languagedetector';
import {
  common, validation, date, tips, indicators,
} from './locale';

const resolveLanguage = (code) => {
  const defaultFallback = 'pt-BR';

  if (!code || typeof code !== 'string') {
    return defaultFallback;
  }

  const normalizedCode = code.toLowerCase().trim();
  const [language, region] = normalizedCode.split('-');

  const fallbackMap = {
    es: {
      cl: ['es-CL', 'es', defaultFallback],
      mx: ['es-MX', 'es', defaultFallback],
      default: ['es', defaultFallback],
    },
    en: {
      default: ['en', defaultFallback],
    },
    pt: {
      default: defaultFallback,
    },
  };

  const languageConfig = fallbackMap[language];

  if (!languageConfig) {
    return defaultFallback;
  }

  return languageConfig[region] || languageConfig.default;
};


const options = {
  order: ['navigator'],
};

const generateLanguageResources = () => ({
  en: {
    common: common.en,
    validation: validation.en,
    date: date.en,
    tips: tips.en,
    indicators: indicators.en,
  },
  es: {
    common: common.es,
    validation: validation.es,
    date: date.es,
    tips: tips.es,
    indicators: indicators.es,
  },
  'es-CL': {
    common: common.escl,
    validation: validation.escl,
    date: date.escl,
    tips: tips.escl,
    indicators: indicators.escl,
  },
  'es-MX': {
    common: common.esmx,
    validation: validation.esmx,
    date: date.esmx,
    tips: tips.esmx,
    indicators: indicators.esmx,
  },
  'pt-BR': {
    common: common.ptbr,
    validation: validation.ptbr,
    date: date.ptbr,
    tips: tips.ptbr,
    indicators: indicators.ptbr,
  },
});
const resources = generateLanguageResources();
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(languageDetector)
  .init({
    resources,
    fallbackLng: resolveLanguage,
    detection: options,
  });

console.log('Current language:', i18n.language);
i18n.changeLanguage(resolveLanguage(i18n.language));
console.log('Final language:', i18n.language);

export default i18n;
